module.exports = __webpack_public_path__ + "static/media/ol.f3e16d90.svg";